export default "__VITE_ASSET__Cy1m_d9u__"